<script>
import { List } from "ant-design-vue";
export default {
	name: "YwList",
	extends: List,
};
</script>
<style lang="less" scoped>
::v-deep .ant-spin-dot {
	width: 30px;
	height: 30px;
	margin: auto;
	position: relative;
	&.ant-spin-dot-spin {
		animation: none;
		transform: none;
		i {
			display: none;
		}
	}
	&:before {
		content: "";
		width: 30px;
		height: 5px;
		background: #000;
		opacity: 0.25;
		position: absolute;
		top: 45px;
		left: 0;
		border-radius: 50%;
		animation: shadow 0.5s linear infinite;
	}
	&:after {
		content: "";
		width: 100%;
		height: 100%;
		background: #5286ec;
		animation: bxSpin 0.5s linear infinite;
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 4px;
	}
}

@keyframes bxSpin {
	17% {
		border-bottom-right-radius: 3px;
	}
	25% {
		transform: translateY(9px) rotate(22.5deg);
	}
	50% {
		transform: translateY(18px) scale(1, 0.9) rotate(45deg);
		border-bottom-right-radius: 40px;
	}
	75% {
		transform: translateY(9px) rotate(67.5deg);
	}
	100% {
		transform: translateY(0) rotate(90deg);
	}
}

@keyframes shadow {
	0%,
	100% {
		transform: scale(1, 1);
	}
	50% {
		transform: scale(1.2, 1);
	}
}
@keyframes slidein {
	from {
		transform: translateX(15px);
		opacity: 0;
	}

	to {
		transform: translateX(0);
		opacity: 1;
	}
}

@keyframes slideout {
	from {
		transform: translateX(0px);
		opacity: 0.6;
	}

	to {
		transform: translateX(15px);
		opacity: 0;
	}
}
</style>
